export enum PartCategoryUIMessages {
  LOAD_Part_Category_LIST_ERROR = 'An error occurred while loading the list of Part Categories.',
  LOAD_Part_Category_ERROR = 'An error occurred while loading the Part Category.',
  ADD_Part_Category_SUCCESS = 'Part Category successfully created.',
  ADD_Part_Category_ERROR = 'An error occurred while creating the Part Category.',
  EDIT_Part_Category_SUCCESS = 'Part Category successfully updated.',
  EDIT_Part_Category_ERROR = 'An error occurred while updating the Part Category.'
}
